import React, { Component } from "react";
import { Row, Col, Card, Button, Container } from "react-bootstrap";
import BreadcrumbsSection from "../../breadcrumbs/BreadcrumbsSection";
import DataTableWithOutSearch from "../../datatables/DataTableWithOutSearch";
import CategoryModal from "./CategoryModal";
import CategoryModalEdit from "./CategoryModalEdit";
import { PageCardShimmer } from "../../preloader/PageCardShimmer";

//import { Data, Columns, defaultSorted } from "./CategoryTableData";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from 'moment';

const GETDATA = gql`
  query($institution_id: Int!) {
    getCategories(institution_id: $institution_id) {
      id
      category_name
      package_id
      package_name
      # exams_covered
      high_difficult
      difficult
      moderate
      easy
      timestamp
    }
  }
`;

const DELETE_QUERY = gql`
  mutation($category_id: ID) {
    deleteCategory(category_id: $category_id)
  }
`;

const FIN = {
  wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
  cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
  iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
  titleText: { display: "flex", flexDirection: "column", textAlign: "left" },
  title: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
  subtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
  countChip: { background: "#f5f3ff", color: "#7c3aed", borderRadius: 20, padding: "4px 12px", fontWeight: 600, fontSize: 12, border: "1px solid #ddd6fe" },
  headerActions: { display: "flex", gap: 10, marginLeft: "auto", alignItems: "center", flexWrap: "wrap" },
  btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
  content: { padding: "20px 24px" },
};

class CategorySection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      BreadcrumbData: {
        Title: "Category",
        btnName: "Add Category"
      },
      tableHeaderData: {
        Title: "Category"
      },
      modalShow: false,
      modalShow1: false,
      status: "1"
    };
  }

  actionsFormatter(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" className="text-theme">
          <i className="far fa-edit" />
        </Button>
      </div>
    );
  }

  actionsFormatter2(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" className="text-danger">
          <i className="far fa-trash-alt" />
        </Button>
      </div>
    );
  }

  handleEditFunction = async (e, cell, row, rowIndex, formatExtraData) => {
    console.log("handleedit", row, rowIndex);
    this.setState({
      modalShow1: true,
      editRow: rowIndex
    });
  };
  handleDelete = async (e, cell, row, rowIndex, formatExtraData) => {
    // console.log("Delete Student Parent", rowIndex);

    await this.props.deletedata({
      variables: {
        category_id: rowIndex.id
      },
      update: (store, { data }) => {
        console.log("data", data);
        const data1 = store.readQuery({
          query: GETDATA,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });

        console.log("rowIndex.id", rowIndex.id);

        data1.getCategories = data1.getCategories.filter(x => x.id != rowIndex.id);

        try {
          store.writeQuery({
            query: GETDATA,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid"))
            },
            data: data1
          });
        } catch (e) {
          console.log("Exception", e);
        }

        const data2 = store.readQuery({
          query: GETDATA,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        });

        console.log("deleted data", data2);

        data1.getCategories = data2;

        if (data.deleteCategory) {
          this.setState({
            status: 2
          });

          setTimeout(() => {
            this.DeleteSetpageLoad();
          }, 1000);
        }
      }
    });
  };
  DeleteSetpageLoad = () => {
    console.log("setTimeout");
    this.setState({ status: 1 });
  };

  onHide = () => {
    console.log("OnHide", "calling parent");
    this.setState({ modalShow1: false });
  };

  Columns = [
    {
      dataField: "category_name",
      text: "Category",
      sort: true
    },
    {
      dataField: "high_difficult",
      text: "High Difficulty",
      sort: true,
      headerAlign: "left",
      align: "left"
    },
    {
      dataField: "difficult",
      text: "Difficulty",
      sort: true,
      headerAlign: "left",
      align: "left"
    },
    {
      dataField: "moderate",
      text: "Moderate",
      sort: true,
      headerAlign: "left",
      align: "left"
    },
    {
      dataField: "easy",
      text: "Easy",
      sort: true,
      headerAlign: "left",
      align: "left"
    },
    {
      dataField: "package_name",
      text: "Package Name",
      sort: true,
      headerAlign: "left",
      align: "left"
    },
    // {
    //   dataField: "exams_covered",
    //   text: "Exam",
    //   sort: true,
    //   headerAlign: "left",
    //   align: "left"
    // },
    {
      dataField: "timestamp",
      text: "Created On",
      sort: true
    },
    {
      dataField: "actions",
      text: "Actions",
      sort: true,
      formatter: this.actionsFormatter,
      headerAttrs: { width: 50 },
      headerAlign: "center",
      align: "center",
      attrs: { width: 50, className: "EditRow" },
      events: {
        onClick: this.handleEditFunction
      }
    },
    {
      dataField: "dactions",
      text: "",
      sort: true,
      formatter: this.actionsFormatter2,
      headerAttrs: { width: 50 },
      headerAlign: "center",
      align: "center",
      attrs: { width: 50, className: "DeleteRow" },
      events: {
        onClick: this.handleDelete
      }
    }
  ];

  defaultSorted = [
    {
      dataField: "title",
      order: "desc"
    }
  ];
  render() {


    if (this.props.getCategories.loading) return <PageCardShimmer filters={4} />;
    let categories = [];
    this.props.getCategories.getCategories.map((citem) => {
      if (citem != undefined) {
        const newObj = {
          id: citem.id,
          category_name: citem.category_name,
          package_id: citem.package_id,
          package_name: citem.package_name,

          high_difficult: citem.high_difficult,
          difficult: citem.difficult,
          moderate: citem.moderate,
          easy: citem.easy,
          timestamp: moment.unix(citem.timestamp).format("YYYY/MM/DD")
        }
        categories.push(newObj);
      }

    });

    //const categories = this.props.getCategories.getCategories;
    console.log("parent categories", categories);

    return (
      <div style={FIN.wrapper}>
        <Container fluid className="px-0">
          <div style={FIN.card}>
            <div style={FIN.cardHeader}>
              <div style={FIN.iconWrapper}><i className="fal fa-layer-group" /></div>
              <div style={FIN.titleText}>
                <h5 style={FIN.title}>Categories</h5>
                <span style={FIN.subtitle}>Manage difficulty categories</span>
              </div>
              <div style={FIN.headerActions}>
                <span style={FIN.countChip}>{categories.length} Categories</span>
                <button style={FIN.btnPrimary} onClick={() => this.setState({ modalShow: true })}>
                  <i className="fas fa-plus" /> Add Category
                </button>
              </div>
            </div>
            <div style={FIN.content}>
              {this.state.status == 2 ? <p style={{ color: "#059669", fontWeight: 600 }}>Category deleted successfully</p> : null}
              <DataTableWithOutSearch
                parentData={categories}
                particlecolumns={this.Columns}
                defaultSorted={this.defaultSorted}
                tableHeading={this.state.tableHeaderData}
              />
            </div>
          </div>
        </Container>
        <CategoryModal
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
        />
        <CategoryModalEdit
          show={this.state.modalShow1}
          categories={categories}
          editRow={this.state.editRow}
          onHide={this.onHide}
        />
      </div>
    );
  }
}

export default compose(
  graphql(GETDATA, {
    options: props => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid"))
      },
      fetchPolicy: 'network-only'


    }),
    name: "getCategories"
  }),

  graphql(DELETE_QUERY, {
    name: "deletedata"
  })
)(CategorySection);
